export default (state={}, action) => {
  switch (action.type) {
    case 'landing':
      return {
        ...state,
        landing: action.payload
      };
    default:
      return state;
  }
};